// extracted by mini-css-extract-plugin
export default {"pagination-container":"_4SpFb","paginationContainer":"_4SpFb"};